const CART_CONST = {
    ADD_ITEM: "ADD_ITEM_TO_CART",
    REMOVE_ITEM: "REMOVE_ITEM_FROM_CART",
    MERGE_CUSTOMER_CART: "MERGE_CUSTOMER_CART_ITEMS",
    EMPTY_CART: "EMPTY_CART",
    ADD_ITEMS: "ADD_ITEMS_IN_BULK"
}

export default CART_CONST;